import Api from "@/services/api";
import { CopyStyle, Style, StyleUsage } from "@/services/styles/types";

export async function getAllStyles(): Promise<Array<Style>> {
    return new Promise((resolve, reject) => {
        Api.get("/styles").then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getFilteredStyles(itemType: string): Promise<Array<Style>> {
    return new Promise((resolve, reject) => {
        Api.post("/styles/filteredStyles", { postType: itemType }).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getStyle(id: string): Promise<Style> {
    return new Promise((resolve, reject) => {
        Api.get(`/styles/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function createStyle(model: Style): Promise<void> {
    return new Promise((resolve, reject) => {
        Api.post("/styles", model).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function updateStyle(model: Style): Promise<void> {
    return new Promise((resolve, reject) => {
        Api.put("/styles", model).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function deleteStyle(id: string): Promise<void> {
    return new Promise((resolve, reject) => {
        Api.delete(`/styles/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function checkStyleUsage(id: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
        Api.get(`/styles/checkUsage/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getStyleUsage(id: string): Promise<StyleUsage> {
    return new Promise((resolve, reject) => {
        Api.get(`/styles/usage/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getStyleByType(type: string): Promise<Array<Style>> {
    return new Promise((resolve, reject) => {
        Api.get(`/styles/type/${type}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function copyStyle(model: CopyStyle): Promise<void> {
    return new Promise((resolve, reject) => {
        Api.post("/styles/copy", model).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}
